import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormArray, FormBuilder, FormGroup} from '@angular/forms';

@Component({
  selector: 'kv-promo-layout-detail',
  template: `
    <div class="Customers customer-company ui-g">
      <div class="ui-g ui-fluid" style="width: 100%">
        <div class="ui-g-12">
          <div>
            <div class="ui-g ui-g-nopad form-group master-data">
              <div class="ui-g-12 ui-lg-8 ui-g-nopad">
                <h1 class="step-title">{{ titlePage | translate}}</h1>
              </div>
              <div class="ui-g-12 ui-lg-4 text-right">
                <button
                  pButton
                  type="button"
                  class="k-generic-btn"
                  icon="fa fa-angle-left"
                  iconPos="left" label="Back"
                  (click)="locationBack()">
                </button>
                <button
                  pButton
                  type="button"
                  class="k-generic-btn"
                  icon="fa fa-floppy-o"
                  iconPos="left"
                  label="{{ 'common.save' | translate }}"
                  (click)="save()">
                </button>
              </div>
            </div>
          </div>
          <form *ngIf="formData" [formGroup]="formData">
            <div class="ui-g form-group master-data">
              <div [kv-form-element]="{ label: 'promotion.code', md: '4' }">
                <input
                  type="text"
                  pInputText
                  formControlName="code" />
              </div>
              <div [kv-form-element]="{ label: 'promotion.description', md: '4' }">
                <input
                  type="text"
                  pInputText
                  formControlName="description" />
              </div>
              <div [kv-form-element]="{ label: '', md: '1' }"></div>
              <div [kv-form-element]="{ label: 'promotion.graph', md: '2' }">
                <p-inputSwitch formControlName="flg_graph"></p-inputSwitch>
              </div>
              <div [kv-form-element]="{ label: '', md: '1' }"></div>
              <div [kv-form-element]="{ label: 'promotion.bmpPath', md: '6' }">
                <input
                  type="text"
                  pInputText
                  formControlName="bmp_path" />
              </div>
              <div [kv-form-element]="{ label: 'promotion.bmpRef', md: '6' }">
                <input
                  type="text"
                  pInputText
                  formControlName="bmp_ref" />
              </div>
              <div [kv-form-element]="{ label: 'promotion.barCode', md: '12' }">
                <input
                  type="text"
                  pInputText
                  formControlName="layout_barcode" />
              </div>
              <div [kv-form-element]="{ label: 'promotion.printType', md: '4' }">
                <p-dropdown
                  [options]="printTypes"
                  formControlName="layout_print_type_pid">
                </p-dropdown>
              </div>
              <div [kv-form-element]="{ label: 'promotion.tillType', md: '4' }">
                <p-dropdown
                  [options]="tillTypes"
                  formControlName="layout_till_type_pid">
                </p-dropdown>
              </div>
              <div [kv-form-element]="{ label: 'promotion.template', md: '4' }">
                <p-dropdown
                  [options]="templates"
                  formControlName="layout_template_pid">
                </p-dropdown>
              </div>
              <div [kv-form-element]="{label: 'promotion.otherFields', md: '12'}">
                <kv-promo-layout-detail-fields
                  [form]="formData"
                  [layoutDetailRowPositions]="layoutDetailRowPositions"
                  [details]="details"
                  (deleteElement)="deletePrivacyList($event)">
                </kv-promo-layout-detail-fields>
              </div>
              <button
                pButton
                type="button"
                class="k-generic-btn"
                icon="fa fa-plus-circle"
                label="{{'common.add' | translate}}"
                (click)="addPrivacy()">
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  `
})
export class LayoutDetailComponent implements  OnInit {

  @Input() layout;
  @Input() titlePage;
  @Input() printTypes;
  @Input() tillTypes;
  @Input() templates;
  @Input() layoutDetailRowPositions;

  @Output() hide = new EventEmitter();
  @Output() saveLayout = new EventEmitter();

  details: FormArray;
  formData: FormGroup;

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    this.createForm();
  }

  locationBack() {
    this.hide.emit();
  }

  save() {
    if (!this.layout.id) {
      if (!this.layout.details) {
        /*Creazione nuovo layout SENZA id e SENZA details*/
        this.saveLayout.emit({
          code: this.formData.controls['code'].value,
          description: this.formData.controls['description'].value,
          flg_graph: this.formData.controls['flg_graph'].value,
          bmp_path: this.formData.controls['bmp_path'].value,
          bmp_ref: this.formData.controls['bmp_ref'].value,
          layout_barcode: this.formData.controls['layout_barcode'].value,
          layout_print_type_pid: this.formData.controls['layout_print_type_pid'].value,
          layout_till_type_pid: this.formData.controls['layout_till_type_pid'].value,
          layout_template_pid: this.formData.controls['layout_template_pid'].value
        })
      } else {
        /*Creazione nuovo layout SENZA id e CON details*/
        this.saveLayout.emit({
          code: this.formData.controls['code'].value,
          description: this.formData.controls['description'].value,
          flg_graph: this.formData.controls['flg_graph'].value,
          bmp_path: this.formData.controls['bmp_path'].value,
          bmp_ref: this.formData.controls['bmp_ref'].value,
          layout_barcode: this.formData.controls['layout_barcode'].value,
          layout_print_type_pid: this.formData.controls['layout_print_type_pid'].value,
          layout_till_type_pid: this.formData.controls['layout_till_type_pid'].value,
          layout_template_pid: this.formData.controls['layout_template_pid'].value,
          details: this.formData.controls['details'].value
        })
      }
    } else {
      if (!this.layout.details) {
        this.saveLayout.emit({
          id: this.layout.id,
          code: this.formData.controls['code'].value,
          description: this.formData.controls['description'].value,
          flg_graph: this.formData.controls['flg_graph'].value,
          bmp_path: this.formData.controls['bmp_path'].value,
          bmp_ref: this.formData.controls['bmp_ref'].value,
          layout_barcode: this.formData.controls['layout_barcode'].value,
          layout_print_type_pid: this.formData.controls['layout_print_type_pid'].value,
          layout_till_type_pid: this.formData.controls['layout_till_type_pid'].value,
          layout_template_pid: this.formData.controls['layout_template_pid'].value
        })
      } else {
        this.saveLayout.emit({
          id: this.layout.id,
          code: this.formData.controls['code'].value,
          description: this.formData.controls['description'].value,
          flg_graph: this.formData.controls['flg_graph'].value,
          bmp_path: this.formData.controls['bmp_path'].value,
          bmp_ref: this.formData.controls['bmp_ref'].value,
          layout_barcode: this.formData.controls['layout_barcode'].value,
          layout_print_type_pid: this.formData.controls['layout_print_type_pid'].value,
          layout_till_type_pid: this.formData.controls['layout_till_type_pid'].value,
          layout_template_pid: this.formData.controls['layout_template_pid'].value,
          details: this.formData.controls['details'].value
        })
      }
    }
  }

  createForm() {
    this.formData = this.fb.group({
      'code': this.layout.code,
      'description': this.layout.description,
      'flg_graph': this.layout.flg_graph,
      'bmp_path': this.layout.bmp_path,
      'bmp_ref': this.layout.bmp_ref,
      'layout_barcode': this.layout.layout_barcode,
      'layout_print_type_pid': this.layout.layout_print_type_pid,
      'layout_till_type_pid': this.layout.layout_till_type_pid,
      'layout_template_pid': this.layout.layout_template_pid,
      'details': this.fb.array([])
    });

    this.populatePrivacyListArray();

  }

  populatePrivacyListArray() {
    this.details = this.formData.get('details') as FormArray;
    for (let det of this.layout.details){
      this.details.push(this.fb.group({
        'row_num': det.row_num,
        'description': det.description,
        'row_style': det.row_style,
        'row_position_pid': det.row_position_pid,
        'row_value': det.row_value,
        'flg_graph': det.flg_graph,
        'bmp_path': det.bmp_path,
        'bmp_ref': det.bmp_ref
      }));
    }
  }

  addPrivacy() {
    this.details = this.formData.get('details') as FormArray;
    this.details.push(this.fb.group({
      'row_num': 0,
      'description': '',
      'row_style': '',
      'row_position_pid': null,
      'row_value': 0,
      'flg_graph': '',
      'bmp_path': '',
      'bmp_ref': ''
    }));
  }

  deletePrivacyList(index) {
    this.details = this.formData.get('details') as FormArray;
    this.details.removeAt(index);
  }

}



// WEBPACK FOOTER //
// ./src/app/views/promotion/layout/components/layoutDetail.component.ts